var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkInfo = function SvgMarkInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.095 4.5a.9.9 0 0 1 .9-.9h.01a.9.9 0 1 1 0 1.8h-.01a.9.9 0 0 1-.9-.9m.9 2.6a.9.9 0 0 1 .9.9v3.5a.9.9 0 1 1-1.8 0V8a.9.9 0 0 1 .9-.9"
  })));
};
export { SvgMarkInfo as ReactComponent };